module.exports = __webpack_public_path__ + "static/media/restart-bottom.980c12d5.jpg";